// @flow
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { APIErrorScreen } from 'common/components/core/errors/APIErrorScreen';
import AuthenticationActions from './AuthenticationActions';

const parseError = error => {
    try {
        const { error: code, message, params } = JSON.parse(error);
        return {
            code,
            message,
            params
        };
    } catch (err) {
        return {
            message: error,
            params: {}
        };
    }
};

type Props = {
    error: { message: string, error_description: string }
};

const AuthError = ({ error }: Props): React.Node => {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    const goHome = () => {
        history.push('/');
    };

    const parsedErrorDesc = parseError(error.error_description);

    if (parsedErrorDesc.code === 'credentials_expired') {
        const url = history.createHref({
            pathname: `/changePassword?userId=${parsedErrorDesc.params.userId}`
        });
        // NOTE: not using router history, instead href
        // to also reload the page to reset the auth error state
        window.location.href = `/${url}`;
        return null;
    }

    return (
        <APIErrorScreen
            onActionClick={goHome}
            actionLabel={t('tryAgain')}
            onSecondaryActionClick={() =>
                dispatch(AuthenticationActions.logout())
            }
            secondaryActionLabel={t('signOut')}
            message={error.message}
            subtitle={error.error_description}
        />
    );
};

export default AuthError;
